import React from 'react'
import { Loader2, AlertTriangle } from 'lucide-react'

interface ProcessingOverlayProps {
  message?: string
}

export function ProcessingOverlay({ message = 'Processing Results' }: ProcessingOverlayProps) {
  return (
    <div className="fixed inset-0 z-[100] bg-background/80 backdrop-blur-sm">
      <div className="fixed inset-0 flex items-center justify-center">
        <div className="max-w-lg p-6 space-y-6 bg-card rounded-lg border-2 border-primary/20 shadow-lg">
          <div className="flex items-center gap-4">
            <Loader2 className="h-8 w-8 text-primary animate-spin" />
            <div>
              <h3 className="text-lg font-semibold">{message}</h3>
              <p className="text-sm text-muted-foreground">
                Please wait while our AI system analyzes the responses. This process typically takes 1-2 minutes to complete.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 rounded-lg bg-yellow-50 border border-yellow-200 dark:bg-yellow-900/10 dark:border-yellow-900/20">
            <AlertTriangle className="h-5 w-5 text-yellow-600 dark:text-yellow-500 flex-shrink-0" />
            <p className="text-sm text-yellow-800 dark:text-yellow-200">
              <strong>DO NOT CLOSE YOUR BROWSER</strong> - Closing this window will interrupt the analysis and may result in data loss.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}